import { AddressDto, UserDto } from '@act/shared/data-transfer-objects';
import { IconLibrary } from '@act/storybook';
import { Typography } from '@mui/material';
import { Fragment } from 'react';
import useAddressDialog from 'react-components/dialog-forms/hooks/use-address-dialog';
import AddressEntry from '../AddressEntry';
import { CollapsibleCardContent, CollapsibleCardHeader } from '@act/storybook';

export interface AddressContactCardProps {
  member: UserDto;
  addresses: AddressDto[];
  defaultClosed?: boolean;
  onToggle?: () => void;
}

const AddressContactContent = ({
  member,
  addresses,
}: AddressContactCardProps) => {
  const openAddressDialog = useAddressDialog();

  return (
    <>
      <CollapsibleCardHeader
        title="Home address"
        titleTypographyVariant="subheadMedium"
        avatar={<IconLibrary iconName="House" size={24} />}
        actions={[
          {
            display: 'Edit address',
            disabled: !addresses?.length,
            callback: () =>
              openAddressDialog({
                mode: 'Edit',
                memberId: member?.id,
                addresses,
              }),
          },
        ]}
        secondaryActions={[
          {
            display: 'Add address',
            callback: () =>
              openAddressDialog({
                mode: 'Add',
                memberId: member?.id,
                addresses,
              }),
          },
          {
            display: 'Set primary address',
            disabled: !addresses?.length,
            callback: () =>
              openAddressDialog({
                mode: 'SetPrimary',
                memberId: member?.id,
                addresses,
              }),
          },
          {
            display: 'Delete address',
            disabled: !addresses?.length,
            callback: () => {
              void openAddressDialog({
                mode: 'Delete',
                memberId: member?.id,
                addresses,
              });
            },
          },
        ]}
      />
      <CollapsibleCardContent twoColumn>
        {!addresses?.length && <Typography>No record found</Typography>}
        {!!addresses?.length && (
          <Fragment>
            {addresses.map(a => (
              <AddressEntry address={a} key={a.id} />
            ))}
          </Fragment>
        )}
      </CollapsibleCardContent>
    </>
  );
};

export default AddressContactContent;
